module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai753-f4d0d861232d43bdc0c84ea68c910b4f.jpg";